module.exports = __webpack_public_path__ + "img/proud.13189e30.png";